/**
 * i18n Configuration - Internationalization Setup
 *
 * Supports: French (fr), English (en), Arabic (ar)
 * - Detects browser language
 * - Stores preference in localStorage
 * - Provides RTL support for Arabic
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  ar: { translation: ar },
};

// Detect locale from URL path (/en/ → en, /ar/ → ar).
// Takes priority over localStorage so /en/ and /ar/ shells work correctly.
const pathLocaleDetector = {
  name: 'pathLocale',
  lookup() {
    const p = typeof window !== 'undefined' ? window.location.pathname : '';
    if (p.startsWith('/en')) return 'en';
    if (p.startsWith('/ar')) return 'ar';
    return undefined;
  },
  cacheUserLanguage() {},
};

const detector = new LanguageDetector();
detector.addDetector(pathLocaleDetector);

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['pathLocale', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
  });

// Export helper to check if current language is RTL
export const isRTL = () => (i18n.resolvedLanguage || i18n.language)?.split('-')[0] === 'ar';

// Export helper to get direction
export const getDirection = () => (i18n.resolvedLanguage || i18n.language)?.split('-')[0] === 'ar' ? 'rtl' : 'ltr';

export default i18n;
